<!-- MOBILE VIEW (hidden ≥768px) -->
<app-mobile-business-view #mobileBusinessView class="d-md-none"
  [activeTab]="mainActiveTab"
  [isFirstLogin]="isFirstLogin"
  [setupCompleted]="mobileSetupCompleted"
  [businessName]="businessName"
  [location]="location"
  [businessBrief]="businessBrief"
  [industry]="industry"
  [businessType]="businessType"
  [vendorType]="vendorType"
  [targetMarket]="targetMarket"
  [salesChannel]="salesChannel"
  [keyChallenges]="keyChallenges"
  [industries]="industries"
  [filteredBusinessTypes]="filteredBusinessTypes"
  [targetMarkets]="targetMarkets"
  [vendorTypes]="vendorTypes"
  [salesChannels]="salesChannels"
  [operatingHours]="operatingHours"
  [daysOfWeek]="daysOfWeek"
  [allDaysOpenTime]="allDaysOpenTime"
  [allDaysCloseTime]="allDaysCloseTime"
  [exceptions]="exceptions"
  [variableOverheadItems]="variableOverheadItems"
  [fixedOverheadItems]="fixedOverheadItems"
  [employeeSalaries]="employeeSalaries"
  [employees]="employees"
  [roles]="roles"
  [periodTypes]="periodTypes"
  [variableOverheads]="variableOverheads"
  [fixedOverheads]="fixedOverheads"
  [unitsOfMeasure]="unitsOfMeasure"
  (businessNameChange)="businessName = $event"
  (locationChange)="location = $event"
  (businessBriefChange)="businessBrief = $event"
  (industryChange)="industry = $event; onIndustryChange()"
  (businessTypeChange)="businessType = $event"
  (vendorTypeChange)="vendorType = $event ?? ''"
  (targetMarketChange)="targetMarket = $event"
  (salesChannelChange)="salesChannel = $event"
  (keyChallengesChange)="keyChallenges = $event"
  (allDaysOpenTimeChange)="allDaysOpenTime = $event"
  (allDaysCloseTimeChange)="allDaysCloseTime = $event"
  (applyToAllDays)="applyToAllDays()"
  (applyAllDays247)="applyAllDays24_7()"
  (toggleDay24HoursEvent)="toggleDay24Hours($event)"
  (addException)="addException()"
  (removeException)="removeException($event)"
  (addVariableOverhead)="addVariableOverhead(); mobileBusinessView.openOffcanvasNewVariable()"
  (saveVariableOverheadItem)="onSaveVariableOverheads()"
  (cancelVariableOverheadAdd)="variableOverheadItems.splice(variableOverheadItems.indexOf($event), 1)"
  (deleteVariableOverhead)="removeVariableOverhead($event, true)"
  (addFixedOverhead)="addFixedOverhead(); mobileBusinessView.openOffcanvasNewFixed()"
  (saveFixedOverheadItem)="onSaveFixedOverheads()"
  (cancelFixedOverheadAdd)="fixedOverheadItems.splice(fixedOverheadItems.indexOf($event), 1)"
  (deleteFixedOverhead)="removeFixedOverhead($event, true)"
  (addSalary)="addNewSalary(); mobileBusinessView.openOffcanvasNewSalary()"
  (saveSalaryItem)="saveSalaryInline($event, employeeSalaries.indexOf($event))"
  (cancelSalaryAdd)="employeeSalaries.splice(employeeSalaries.indexOf($event), 1)"
  (deleteSalaryItem)="deleteSalary($event, true)"
  (addEmployee)="addNewEmployee(); mobileBusinessView.openOffcanvasNewEmployee()"
  (saveEmployeeItem)="saveEmployeeInline($event, employees.indexOf($event))"
  (cancelEmployeeAdd)="employees.splice(employees.indexOf($event), 1)"
  (deleteEmployeeItem)="deleteEmployee($event, true)"
  (submit)="onMobileSubmit($event)">
</app-mobile-business-view>

<!-- DESKTOP VIEW (hidden <768px) -->
<div class="d-none d-md-block">
<div class="container-fluid">
  <!-- Welcome section similar to other dashboards -->
  <div class="welcome-section mb-4 fade-in">
    <div
      class="d-flex justify-content-between align-items-center business-header"
    >
      <div>
        <div class="d-flex align-items-center">
          <h2 class="fw-bold">Business Details</h2>
        </div>

        <h4 class="welcome-text">
          Manage Company profile and Operational Variables
        </h4>
      </div>
      <div class="text-end">
        <small class="text-muted d-block">Current User:</small>
        <h6 class="mb-0">{{ fullName }}</h6>
        <small class="text-muted d-block">{{ tenantName }}</small>
      </div>
    </div>
  </div>

  <div class="business-form shadow-sm p-4 bg-white mb-4">
    <form (ngSubmit)="onSubmit()">
      <!-- First-login progress strip -->
      <div *ngIf="isFirstLogin" class="setup-progress mb-3">
        <div class="setup-progress-bar">
          <div class="setup-progress-fill" [style.width.%]="((currentTabIndex + 1) / tabs.length) * 100"></div>
        </div>
        <span class="setup-progress-label">{{ progressLabel }}</span>
      </div>

      <!-- Bootstrap Tab Navigation -->
      <nav class="form-tabs border-none">
        <div class="nav" role="tablist">
          <button
            class="nav-link"
            [class.active]="mainActiveTab === 'details'"
            (click)="onTabChange('details')"
            id="details-tab"
            type="button"
            role="tab"
          >
            <i class="bi bi-building me-2"></i>Details
          </button>

          <!-- Operating Schedule Tab -->
          <button
            class="nav-link"
            [class.active]="mainActiveTab === 'schedule'"
            (click)="onTabChange('schedule')"
            id="schedule-tab"
            type="button"
            role="tab"
          >
            <i class="bi bi-clock me-2"></i>Operating Schedule
          </button>

          <!-- Expenses Tab -->
          <button
            class="nav-link"
            [class.active]="mainActiveTab === 'expenses'"
            (click)="onTabChange('expenses')"
            id="expenses-tab"
            type="button"
            role="tab"
          >
            <i class="bi bi-graph-up me-2"></i>Expenses
          </button>

          <!-- Employees Tab -->
          <button
            class="nav-link"
            [class.active]="mainActiveTab === 'employees'"
            (click)="onTabChange('employees')"
            id="employees-tab"
            type="button"
            role="tab"
          >
            <i class="bi bi-people me-2"></i>Employees
          </button>
        </div>
      </nav>

      <div class="tab-content" id="businessFormTabsContent">
        <div
          class="tab-pane fade show active pt-3"
          id="details"
          role="tabpanel"
          aria-labelledby="details-tab"
          [class.show]="mainActiveTab === 'details'"
          [class.active]="mainActiveTab === 'details'"
          [hidden]="mainActiveTab !== 'details'"
        >
          <!-- Primary business information section -->
          <div class="form-section primary-section mb-4">
            <div class="section-header">
              <div class="section-icon">
                <i class="bi bi-building"></i>
              </div>
              <h4 class="section-title">Primary Business Information</h4>
            </div>

            <div class="row g-3">
              <div class="col-md-6">
                <div class="form-group">
                  <label for="businessName" class="form-label"
                    >Business Name</label
                  >
                  <app-tooltip [tooltipId]="'business-name'">
                    <i icon class="bi bi-info-circle"></i>
                    <div content>
                      <p class="text-start">
                        The official registered name of the business. If the
                        business is not registered put the name that you trade
                        under.
                      </p>
                    </div>
                  </app-tooltip>
                  <input
                    type="text"
                    id="businessName"
                    [(ngModel)]="businessName"
                    name="businessName"
                    class="form-control"
                    placeholder="Enter your business name"
                    required
                  />
                </div>
              </div>

              <div class="col-md-6">
                <div class="form-group">
                  <label for="location" class="form-label"
                    >Business Physical Address</label
                  >
                  <app-tooltip [tooltipId]="'location'">
                    <i icon class="bi bi-info-circle"></i>
                    <div content>
                      <p class="text-start">
                        The full physical adress: street, suburb, city, postal
                        code.
                      </p>
                    </div>
                  </app-tooltip>
                  <input
                    type="text"
                    id="location"
                    [(ngModel)]="location"
                    name="location"
                    class="form-control"
                    placeholder="Enter your business location"
                    required
                  />
                </div>
              </div>

              <div class="col-md-12">
                <div class="form-group">
                  <label for="businessBrief" class="form-label"
                    >Business Brief Description</label
                  >

                  <app-tooltip [tooltipId]="'business-tooltip'">
                    <i icon class="bi bi-info-circle"></i>
                    <div content>
                      <p class="text-start">
                        This is where you describe what your business does.<br />
                        Explain as comprehensively as possible for personalised
                        and unique AI recommendations.
                      </p>
                    </div>
                  </app-tooltip>

                  <textarea
                    id="businessBrief"
                    [(ngModel)]="businessBrief"
                    name="businessBrief"
                    class="form-control"
                    placeholder="Briefly describe your business"
                    rows="3"
                    required
                  ></textarea>
                </div>
              </div>
            </div>
          </div>

          <!-- Business classification section -->
          <div class="form-section classification-section mb-4">
            <div class="section-header">
              <div class="section-icon">
                <i class="bi bi-diagram-3"></i>
              </div>
              <h4 class="section-title">Business Classification</h4>
            </div>

            <div class="row g-3">
              <!-- Industry selector -->
              <div class="col-md-6 mb-3">
                <label class="form-label">Industry Sector</label>

                <app-tooltip [tooltipId]="'industry-tooltip'">
                  <i icon class="bi bi-info-circle"></i>
                  <div content>
                    <p class="text-start">
                      Select the sector which accurately aligns with your
                      business.
                    </p>
                  </div>
                </app-tooltip>
                <app-single-select-dropdown
                  id="industry"
                  name="industry"
                  [options]="industries"
                  placeholder="Select Industry"
                  [(selectedValue)]="industry"
                  (selectedValueChange)="onIndustryChange()"
                  required
                >
                </app-single-select-dropdown>
              </div>

              <!-- Business Type selector -->
              <div class="col-md-6 mb-3">
                <label class="form-label">Business Type</label>
                <app-tooltip [tooltipId]="'Sub-Category'">
                  <i icon class="bi bi-info-circle"></i>
                  <div content>
                    <p class="text-start">
                      This is the exact business in the sector.<br />
                      Select the appropriate option.
                    </p>
                  </div>
                </app-tooltip>
                <app-single-select-dropdown
                  id="businessType"
                  name="businessType"
                  [options]="filteredBusinessTypes"
                  placeholder="Select Sector Category"
                  [(selectedValue)]="businessType"
                  [disabled]="!industry"
                  required
                >
                </app-single-select-dropdown>
              </div>

              <!-- Vendor Type -->
              <div class="col-md-6 mb-3">
                <label class="form-label">Vendor Type</label>
                <app-tooltip [tooltipId]="'vat-vendor'">
                  <i icon class="bi bi-info-circle"></i>
                  <div content>
                    <p class="text-start">Select the appropriate option.</p>
                  </div>
                </app-tooltip>
                <app-single-select-dropdown
                  id="vendorType"
                  name="vendorType"
                  [options]="vendorTypes"
                  placeholder="Select Vendor Type"
                  [(selectedValue)]="vendorType"
                  required
                >
                </app-single-select-dropdown>
              </div>
            </div>
          </div>

          <!-- Business model section -->

          <!-- Market & sales section -->
          <div class="form-section market-section mb-4">
            <div class="section-header">
              <div class="section-icon">
                <i class="bi bi-shop"></i>
              </div>
              <h4 class="section-title">Target Market & Sales</h4>
            </div>

            <div class="row g-3">
              <div class="col-md-6 mb-3">
                <label class="form-label">Target Market</label>
                <app-tooltip [tooltipId]="'market'">
                  <i icon class="bi bi-info-circle"></i>
                  <div content>
                    <p class="text-start">
                      This is your client base that you aim to sell your
                      products to.
                      <br />
                      <strong class="tooltipTextColor"
                        >You can select multiple entries by clicking the
                        checkmarks or the entry options.</strong
                      >
                    </p>
                  </div>
                </app-tooltip>
                <app-multi-select-dropdown
                  [options]="targetMarkets"
                  placeholder="Select Target Markets"
                  [(selectedValues)]="targetMarket"
                  (addMore)="onAddMoreTargetMarket()"
                >
                </app-multi-select-dropdown>
              </div>

              <div class="col-md-6 mb-3">
                <label class="form-label">Sales Channels</label>
                <app-tooltip [tooltipId]="'sales'">
                  <i icon class="bi bi-info-circle"></i>
                  <div content>
                    <p class="text-start">
                      How do you sell your products or reach out your customers?

                      <br />
                      <strong class="tooltipTextColor"
                        >You can select multiple entries by clicking the
                        checkmarks or the entry options.</strong
                      >
                    </p>
                  </div>
                </app-tooltip>
                <app-multi-select-dropdown
                  [options]="salesChannels"
                  placeholder="Select Sales Channels"
                  [(selectedValues)]="salesChannel"
                  (addMore)="onAddMoreSalesChannel()"
                >
                </app-multi-select-dropdown>
              </div>
            </div>
          </div>
          <!-- Challenges -->
          <div class="form-section challenges-section mb-4">
            <div class="d-flex justify-content-between align-items-center">
              <div class="section-header">
                <div class="section-icon">
                  <i class="bi bi-exclamation-triangle"></i>
                </div>
                <div class="d-flex justify-content-center align-items-start">
                  <h4 class="section-title">Business Challenges</h4>
                  <app-tooltip [tooltipId]="'challenges'">
                    <i icon class="bi bi-info-circle"></i>
                    <div content>
                      <p class="text-start">
                        This is where you list any challenges that your business
                        is facing.<br />Please explain below so that Aivor can
                        analyse and give you personalised and unique AI
                        recommendations.
                      </p>
                    </div>
                  </app-tooltip>
                </div>
              </div>
            </div>

            <div class="form-group mb-3">
              <label for="keyChallenges" class="form-label"
                >Describe your key business challenges:</label
              >
              <textarea
                id="keyChallenges"
                [(ngModel)]="keyChallenges"
                name="keyChallenges"
                class="form-control"
                placeholder="What are the main challenges facing your business?"
                rows="6"
                required
              ></textarea>
            </div>
          </div>
        </div>

        <!-- Operating Schedule Tab -->
        <div
          class="tab-pane fade pt-3"
          id="schedule"
          role="tabpanel"
          aria-labelledby="schedule-tab"
          [class.show]="mainActiveTab === 'schedule'"
          [class.active]="mainActiveTab === 'schedule'"
          [hidden]="mainActiveTab !== 'schedule'"
        >
          <div class="form-section schedule-section mb-5">
            <div class="section-header">
              <div class="section-icon">
                <i class="bi bi-calendar-week"></i>
              </div>
              <h4 class="section-title">Regular Weekly Schedule</h4>
              <app-tooltip [tooltipId]="'variable-OH'" class="ms-2">
                <i icon class="bi bi-info-circle"></i>
                <div content>
                  <p class="text-start">
                    Set your regular operating hours. Check "Closed" for
                    non-working days.
                  </p>
                </div>
              </app-tooltip>
            </div>

            <div class="card border-0 shadow-sm mb-4 p-3 bg-light">
              <h6 class="mb-3 fw-bold text-primary">Apply to All Days</h6>
              <div class="row g-3 align-items-end">
                <div class="col-6 col-md-4">
                  <label class="small text-muted mb-1"
                    >Opening Time (All Days)</label
                  >
                  <input
                    type="time"
                    class="form-control"
                    [(ngModel)]="allDaysOpenTime"
                    [ngModelOptions]="{ standalone: true }"
                    step="60"
                  />
                </div>
                <div class="col-6 col-md-4">
                  <label class="small text-muted mb-1"
                    >Closing Time (All Days)</label
                  >
                  <input
                    type="time"
                    class="form-control"
                    [(ngModel)]="allDaysCloseTime"
                    [ngModelOptions]="{ standalone: true }"
                    step="60"
                  />
                </div>
                <div class="col-12 col-md-4 d-grid">
                  <button
                    type="button"
                    class="btn btn-primary"
                    (click)="applyToAllDays()"
                  >
                    Apply to All
                  </button>
                </div>
                <div class="col-12 d-grid mt-2">
                  <button
                    type="button"
                    class="btn btn-outline-primary"
                    (click)="applyAllDays24_7()"
                  >
                    <i class="bi bi-clock me-1"></i>Open 24/7
                  </button>
                </div>
              </div>
            </div>
            <div
              class="row row-cols-2 row-cols-md-3 row-cols-lg-4 row-cols-xl-7 g-3"
            >
              <div class="col" *ngFor="let day of daysOfWeek; let i = index">
                <div class="card border-0 shadow-sm h-100">
                  <div
                    class="card-header bg-light border-0 py-2"
                    style="background-color: rgba(0, 122, 143, 0.05) !important"
                  >
                    <h6 class="mb-0 fw-medium text-primary">{{ day.name }}</h6>
                  </div>
                  <div class="card-body p-3">
                    <div class="mb-2">
                      <label class="small text-muted mb-1">Opening</label>
                      <input
                        type="time"
                        class="form-control form-control-sm border-0 bg-light"
                        [(ngModel)]="operatingHours[i].openTime"
                        [disabled]="operatingHours[i].isClosed"
                        [ngModelOptions]="{ standalone: true }"
                        step="60"
                      />
                    </div>
                    <div class="mb-3">
                      <label class="small text-muted mb-1">Closing</label>
                      <input
                        type="time"
                        class="form-control form-control-sm border-0 bg-light"
                        [(ngModel)]="operatingHours[i].closeTime"
                        [disabled]="operatingHours[i].isClosed"
                        [ngModelOptions]="{ standalone: true }"
                        step="60"
                      />
                    </div>
                    <div class="form-check form-switch closed-toggle">
                      <div class="d-flex align-items-center">
                        <input
                          class="form-check-input"
                          type="checkbox"
                          [(ngModel)]="operatingHours[i].isClosed"
                          [ngModelOptions]="{ standalone: true }"
                        />
                        <label class="form-check-label small ms-3"
                          >Closed</label
                        >
                      </div>
                    </div>
                    <div class="mt-2">
                      <button
                        type="button"
                        class="btn btn-sm w-100"
                        [ngClass]="isDayOpen24Hours(i) ? 'btn-primary' : 'btn-outline-secondary'"
                        (click)="toggleDay24Hours(i)"
                      >
                        <i class="bi bi-clock me-1"></i>24 Hrs
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="form-section schedule-exceptions-section">
            <div class="d-flex justify-content-between align-items-center mb-3">
              <div class="section-header mb-0">
                <div class="section-icon">
                  <i class="bi bi-calendar-x"></i>
                </div>
                <h4 class="section-title">Special Days &amp; Exceptions</h4>
                <app-tooltip [tooltipId]="'variable-OH'">
                  <i icon class="bi bi-info-circle"></i>
                  <div content>
                    <p class="text-start">
                      This shows the official South African public holidays when
                      businesses have different operating hours and system puts
                      <strong class="tooltipTextColorSave">closed</strong> by
                      default. You can change your opening and closing hours per
                      each holiday by
                      <strong class="tooltipTextColorSave">
                        toggling the closed button</strong
                      >. If you have any other special days eg family
                      commemorations, you can click on the add button.
                    </p>
                  </div>
                </app-tooltip>
              </div>

              <button
                type="button"
                class="btn btn-sm py-1 px-3"
                style="background-color: #007a8f; color: white"
                (click)="addException()"
              >
                <i class="bi bi-plus-lg me-1"></i> Add
              </button>
            </div>

            <div
              *ngIf="exceptions.length === 0"
              class="border rounded bg-light p-5 text-center"
            >
              <i class="bi bi-calendar2-x fs-1" style="color: #007a8f"></i>
              <p class="mt-2 mb-0 fw-medium">No special days added</p>
              <small class="text-muted"
                >Add holidays, special hours, or closure days</small
              >
            </div>

            <div class="exceptions-scroll-container">
              <div class="row g-3">
                <div
                  class="col-12"
                  *ngFor="let exc of exceptions; let i = index"
                >
                  <div class="border rounded-1 p-3 bg-light">
                    <div
                      class="d-flex justify-content-end align-items-center mb-2"
                    >
                      <button
                        type="button"
                        class="btn btn-sm btn-link text-danger p-0"
                        (click)="removeException(i)"
                      >
                        <i class="bi bi-trash"></i>
                      </button>
                    </div>

                    <div class="row g-2">
                      <div class="col-md-4">
                        <label class="form-label small mb-1">Date</label>
                        <input
                          type="date"
                          class="form-control form-control-sm"
                          [(ngModel)]="exc.exceptionDate"
                          [ngModelOptions]="{ standalone: true }"
                        />
                      </div>

                      <div class="col-md-3">
                        <label class="form-label small mb-1"
                          >Opening Time</label
                        >
                        <input
                          type="time"
                          class="form-control form-control-sm"
                          [(ngModel)]="exc.openTime"
                          [disabled]="exc.isClosed"
                          [ngModelOptions]="{ standalone: true }"
                          step="60"
                        />
                      </div>

                      <div class="col-md-3">
                        <label class="form-label small mb-1"
                          >Closing Time</label
                        >
                        <input
                          type="time"
                          class="form-control form-control-sm"
                          [(ngModel)]="exc.closeTime"
                          [disabled]="exc.isClosed"
                          [ngModelOptions]="{ standalone: true }"
                          step="60"
                        />
                      </div>

                      <div class="col-md-2 d-flex align-items-end">
                        <div class="form-check form-switch">
                          <div class="d-flex align-items-center">
                            <input
                              class="form-check-input"
                              type="checkbox"
                              [(ngModel)]="exc.isClosed"
                              [ngModelOptions]="{ standalone: true }"
                            />
                            <label class="form-check-label small ms-3"
                              >Closed</label
                            >
                          </div>
                        </div>
                      </div>

                      <div class="col-12 mt-2">
                        <label class="form-label small mb-1"
                          >Reason (Optional)</label
                        >
                        <input
                          type="text"
                          class="form-control form-control-sm"
                          placeholder="e.g., Public Holiday, Maintenance"
                          [(ngModel)]="exc.reason"
                          [ngModelOptions]="{ standalone: true }"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- end schedule -->
        <div
          class="tab-pane fade pt-3"
          id="expenses"
          role="tabpanel"
          aria-labelledby="expenses-tab"
          [class.show]="mainActiveTab === 'expenses'"
          [class.active]="mainActiveTab === 'expenses'"
          [hidden]="mainActiveTab !== 'expenses'"
        >
          <div class="form-section expenses-section mb-4">
            <div class="section-header-overhead">
              <div class="d-flex align-items-center">
                <div class="section-icon">
                  <i class="bi bi-currency-exchange"></i>
                </div>
                <div class="d-flex p-0 m-0">
                  <h4 class="section-title mb-0">Fixed Costs</h4>
                  <app-tooltip [tooltipId]="'fixed-cost'">
                    <i icon class="bi bi-info-circle"></i>
                    <div content>
                      <p class="text-start">
                        Costs that do not change with production volume e.g.
                        Rent. <br />You can create your own fixed cost if its
                        not availabe in the dropdown list by clicking
                        <strong class="tooltipTextColorSave">
                          Custom Fixed Cost</strong
                        >
                        in the dropdown. <br />
                        <strong class="tooltipTextColorSave"
                          >Your costs are saved when you click the button at
                          the bottom of the page.</strong
                        >
                      </p>
                    </div>
                  </app-tooltip>
                </div>
              </div>

              <div class="d-flex gap-2">
                <button
                  type="button"
                  class="btn btn-primary px-2 py-1 d-flex align-items-center gap-2 rounded-2 mr-2"
                  (click)="addFixedOverhead()"
                >
                  <i class="bi bi-plus fs-4"></i>
                  <span class="">Add Fixed Cost</span>
                </button>
              </div>
            </div>

            <div class="overhead-card-container fixed-overhead-scroll mt-3">
              <ng-container *ngIf="fixedOverheadItems.length > 0; else noFOH">
                <div
                  *ngFor="let item of fixedOverheadItems; let i = index"
                  class="overhead-card"
                  [class.border-danger]="item.flagged"
                  [class.border-2]="item.flagged"
                >
                  <div class="overhead-card-header">
                    <div class="overhead-card-title">
                      <span *ngIf="item.isNew" class="badge bg-success ms-2"
                        >New</span
                      >
                      <span
                        *ngIf="item.isModified && !item.isNew"
                        class="badge bg-warning ms-2"
                        >Modified</span
                      >
                    </div>
                    <div class="d-flex gap-2">
                      <button
                        type="button"
                        class="btn btn-sm btn-outline-primary"
                        (click)="toggleEditMode(item)"
                      >
                        <i
                          class="bi fs-5"
                          [class.bi-pencil]="!item.isEditing"
                          [class.bi-x-lg]="item.isEditing"
                        ></i>
                      </button>
                      <button
                        type="button"
                        class="btn btn-sm"
                        (click)="removeFixedOverhead(i)"
                      >
                        <i class="bi bi-trash-fill fs-5 text-danger"></i>
                      </button>
                    </div>
                  </div>

                  <div class="overhead-card-content" *ngIf="!item.isEditing">
                    <div class="form-group mb-2">
                      <label class="form-label" for="fixedOverheadView{{ i }}"
                        >Fixed Cost Item Name</label
                      >
                      <input
                        type="text"
                        class="form-control"
                        id="fixedOverheadView{{ i }}"
                        [value]="getOverheadTypeDisplay(item)"
                        readonly
                      />
                    </div>

                    <div class="form-group mb-2">
                      <label class="form-label" for="fixedCostView{{ i }}"
                        >Amount Payable</label
                      >
                      <div class="input-group">
                        <span
                          class="input-group-text bg-transparent border-end-0"
                        >
                          <i class="text-secondary">R</i>
                        </span>
                        <input
                          type="text"
                          class="form-control border-start-0"
                          id="fixedCostView{{ i }}"
                          [value]="item.cost | number : '1.2-2'"
                          readonly
                        />
                      </div>
                    </div>

                    <div class="form-group mb-2">
                      <label class="form-label" for="fixedPeriodView{{ i }}"
                        >Payment Period</label
                      >
                      <div class="input-group">
                        <span
                          class="input-group-text bg-transparent border-end-0"
                        >
                          <i class="bi bi-calendar-range text-secondary"></i>
                        </span>
                        <input
                          type="text"
                          class="form-control form-control-sm border-start-0"
                          id="fixedPeriodView{{ i }}"
                          [value]="getPeriodTypeDisplay(item.periodTypeID)"
                          readonly
                        />
                      </div>
                    </div>
                  </div>

                  <div class="overhead-card-content" *ngIf="item.isEditing">
                    <div class="form-group mb-2">
                      <label class="form-label">Fixed Cost Item Name</label>
                      <select
                        [(ngModel)]="item.overhead"
                        name="fixedOverhead{{ i }}"
                        class="form-select"
                        (change)="onFixedOverheadFieldChange(item)"
                      >
                        <option value="" disabled>Select Fixed Overhead</option>
                        <option
                          *ngFor="let option of fixedOverheads"
                          [value]="option.value"
                        >
                          {{ option.label }}
                        </option>
                        <option class="text-primary fs-6" value="custom">
                          Custom Fixed Cost
                        </option>
                      </select>
                      <input
                        *ngIf="item.overhead === 'custom'"
                        type="text"
                        class="form-control mt-2"
                        [(ngModel)]="item.customOverhead"
                        name="customFixedOverhead{{ i }}"
                        placeholder="Custom Fixed Cost Name"
                        (input)="onFixedOverheadFieldChange(item)"
                      />
                      <div
                        *ngIf="item.touched && item.invalidOverhead"
                        class="text-danger mt-1"
                      >
                        Fixed Overhead Name is required.
                      </div>
                    </div>

                    <div class="form-group mb-2">
                      <label class="form-label">Amount Payable</label>
                      <div class="input-group">
                        <span
                          class="input-group-text bg-transparent border-end-0"
                        >
                          <i class="text-secondary">R</i>
                        </span>
                        <input
                          type="number"
                          class="form-control border-start-0"
                          name="fixedCost{{ i }}"
                          [(ngModel)]="item.cost"
                          placeholder="Amount"
                          min="0"
                          (input)="onFixedOverheadFieldChange(item)"
                        />
                      </div>
                      <div
                        *ngIf="item.touched && item.invalidCost"
                        class="text-danger mt-1"
                      >
                        Amount must be a positive number.
                      </div>
                    </div>

                    <div class="form-group mb-2">
                      <label class="form-label">Payment Period</label>
                      <div class="input-group">
                        <span
                          class="input-group-text bg-transparent border-end-0"
                        >
                          <i class="bi bi-calendar-range text-secondary"></i>
                        </span>
                        <select
                          class="form-select form-select-sm border-start-0"
                          [(ngModel)]="item.periodTypeID"
                          name="periodTypeID_{{
                            item.fixedOverheadID || 'new_' + i
                          }}"
                          required
                          (change)="onFixedOverheadFieldChange(item)"
                        >
                          <option [ngValue]="null" disabled>
                            Select Period Type
                          </option>
                          <option
                            *ngFor="let pt of periodTypes"
                            [ngValue]="pt.periodTypeID"
                          >
                            {{ pt.description }}
                          </option>
                        </select>
                      </div>
                      <div
                        *ngIf="item.invalidperiodTypeID"
                        class="text-danger mt-1"
                      >
                        Payment Period is required.
                      </div>
                    </div>
                  </div>
                </div>
              </ng-container>

              <ng-template #noFOH>
                <div class="text-muted text-center mt-3">
                  <i class="bi bi-info-circle me-2"></i>
                  No Fixed Costs Found. Click “Add Fixed Cost” to begin.
                </div>
              </ng-template>
            </div>
          </div>
          <!-- Variable OH Begin -->
          <div class="form-section expenses-section mb-4 fixed-overhead-scroll">
            <div class="section-header-overhead">
              <div class="d-flex align-items-center">
                <div class="section-icon">
                  <i class="bi bi-currency-exchange"></i>
                </div>
                <div class="d-flex p-0 m-0">
                  <h4 class="section-title mb-0">Variable Costs</h4>
                  <app-tooltip [tooltipId]="'variable-OH'">
                    <i icon class="bi bi-info-circle"></i>
                    <div content>
                      <p class="text-start">
                        This is where you specify which costs change with
                        production volume. For example packaging materials or
                        delivery fees. <br />Click add to start adding the
                        cost.<br />
                        <strong class="tooltipTextColorSave"
                          >Your costs are saved when you click the button at
                          the bottom of the page.</strong
                        ><br />
                        <br />
                        <strong class="tooltipTextColorSave"
                          >Click the pencil to edit a cost.</strong
                        ><br /><br />
                        <em>Tip: A unit of measure is a standard unit used to count or quantify something—like using meters (m) to measure length.</em>
                      </p>
                    </div>
                  </app-tooltip>
                </div>
              </div>

              <div class="d-flex gap-2">
                <button
                  type="button"
                  class="btn btn-primary px-2 py-1 d-flex align-items-center gap-2 rounded-2 mr-2"
                  (click)="addVariableOverhead()"
                >
                  <i class="bi bi-plus fs-4"></i>
                  <span class="">Add Variable Cost</span>
                </button>
              </div>
            </div>

            <div class="overhead-card-container variable-overhead-scroll mt-3">
              <ng-container
                *ngIf="variableOverheadItems.length > 0; else noVOH"
              >
                <div
                  *ngFor="let item of variableOverheadItems; let i = index"
                  class="overhead-card"
                  [class.border-danger]="item.flagged"
                  [class.border-2]="item.flagged"
                >
                  <div class="overhead-card-header">
                    <div class="overhead-card-title">
                      <span *ngIf="item.isNew" class="badge bg-success ms-2"
                        >New</span
                      >
                      <span
                        *ngIf="item.isModified && !item.isNew"
                        class="badge bg-warning ms-2"
                        >Modified</span
                      >
                    </div>
                    <div class="d-flex gap-2">
                      <button
                        type="button"
                        class="btn btn-sm btn-outline-primary"
                        (click)="toggleEditModeVariable(item)"
                      >
                        <i
                          class="bi fs-5"
                          [class.bi-pencil]="!item.isEditing"
                          [class.bi-x-lg]="item.isEditing"
                        ></i>
                      </button>
                      <button
                        type="button"
                        class="btn btn-sm"
                        (click)="removeVariableOverhead(i)"
                      >
                        <i class="bi bi-trash-fill fs-5 text-danger"></i>
                      </button>
                    </div>
                  </div>

                  <div class="overhead-card-content" *ngIf="!item.isEditing">
                    <div class="form-group mb-2">
                      <label class="form-label" for="variableOverheadView{{ i }}"
                        >Variable Cost Name</label
                      >
                      <input
                        type="text"
                        class="form-control"
                        id="variableOverheadView{{ i }}"
                        [value]="getVariableOverheadTypeDisplay(item)"
                        readonly
                      />
                    </div>

                    <div class="form-group mb-2">
                      <label class="form-label" for="variableUomView{{ i }}"
                        >Units of Measurement</label
                      >
                      <div class="input-group">
                        <span
                          class="input-group-text bg-transparent border-end-0"
                        >
                          <i class="bi bi-rulers text-secondary"></i>
                        </span>
                        <input
                          type="text"
                          class="form-control form-control-sm border-start-0"
                          id="variableUomView{{ i }}"
                          [value]="getUOMDisplayName(item.uomID)"
                          readonly
                        />
                      </div>
                    </div>

                    <div class="form-group mb-2">
                      <label class="form-label" for="variablePriceView{{ i }}"
                        >Total Cost</label
                      >
                      <div class="input-group">
                        <span
                          class="input-group-text bg-transparent border-end-0"
                        >
                          <i class="text-secondary">R</i>
                        </span>
                        <input
                          type="text"
                          class="form-control border-start-0"
                          id="variablePriceView{{ i }}"
                          [value]="item.purchasePrice | number : '1.2-2'"
                          readonly
                        />
                      </div>
                    </div>

                    <div class="form-group mb-2">
                      <label class="form-label" for="variableQuantityView{{ i }}"
                        >Total Quantity</label
                      >
                      <div class="input-group">
                        <span
                          class="input-group-text bg-transparent border-end-0"
                        >
                          <i class="bi bi-123 text-secondary"></i>
                        </span>
                        <input
                          type="text"
                          class="form-control border-start-0"
                          id="variableQuantityView{{ i }}"
                          [value]="item.purchaseQuantity | number : '1.0-0'"
                          readonly
                        />
                      </div>
                    </div>
                  </div>

                  <div class="overhead-card-content" *ngIf="item.isEditing">
                    <div class="form-group mb-2">
                      <label class="form-label">Variable Cost Name</label>

                      <select
                        [(ngModel)]="item.overhead"
                        name="variableOverheadType{{ i }}"
                        class="form-select"
                        (change)="onVariableOverheadFieldChange(item)"
                      >
                        <option [ngValue]="null" disabled>
                          Select Variable Overhead Name
                        </option>
                        <option
                          *ngFor="let option of variableOverheads"
                          [value]="option.value"
                        >
                          {{ option.label }}
                        </option>
                        <option class="text-primary fs-6" value="custom">
                          Custom Variable Cost
                        </option>
                      </select>
                      <input
                        *ngIf="item.overhead === 'custom'"
                        type="text"
                        class="form-control mt-2"
                        [(ngModel)]="item.customOverhead"
                        name="customVariableOverhead{{ i }}"
                        placeholder="Custom Variable Cost Name"
                        (input)="onVariableOverheadFieldChange(item)"
                      />
                    </div>
                    <div class="form-group mb-2">
                      <label class="form-label">Units of Measurement</label>

                      <div class="input-group">
                        <span
                          class="input-group-text bg-transparent border-end-0"
                        >
                          <i class="bi bi-rulers text-secondary"></i>
                        </span>
                        <select
                          class="form-select form-select-sm border-start-0"
                          [(ngModel)]="item.uomID"
                          name="uomID_{{
                            item.variableOverheadItemID || 'new_voh_' + i
                          }}"
                          required
                          (change)="onVariableOverheadFieldChange(item)"
                        >
                          <option [ngValue]="null" disabled>
                            Select Unit of Measurement
                          </option>
                          <option
                            *ngFor="let uom of unitsOfMeasure"
                            [ngValue]="uom.uomID"
                          >
                          {{ uom.uomCode }}
                          </option>
                        </select>
                      </div>
                    </div>

                    <div class="form-group mb-2">
                      <label class="form-label">Total Cost</label>
                      <div class="input-group">
                        <span
                          class="input-group-text bg-transparent border-end-0"
                        >
                          <i class="text-secondary">R</i>
                        </span>
                        <input
                          type="number"
                          class="form-control border-start-0"
                          name="variablePurchasePrice{{ i }}"
                          [(ngModel)]="item.purchasePrice"
                          placeholder="Total Cost"
                          min="0"
                          (input)="onVariableOverheadFieldChange(item)"
                        />
                      </div>
                      <div
                        *ngIf="item.touched && item.invalidPurchasePrice"
                        class="text-danger mt-1"
                      >
                        Cost must be a positive number.
                      </div>
                    </div>

                    <div class="form-group mb-2">
                      <label class="form-label">Total Quantity</label>
                      <div class="input-group">
                        <span
                          class="input-group-text bg-transparent border-end-0"
                        >
                          <i class="bi bi-123 text-secondary"></i>
                        </span>
                        <input
                          type="number"
                          class="form-control border-start-0"
                          name="variablePurchaseQuantity{{ i }}"
                          [(ngModel)]="item.purchaseQuantity"
                          placeholder="Total Quantity"
                          min="1"
                          (input)="onVariableOverheadFieldChange(item)"
                        />
                      </div>
                      <div
                        *ngIf="item.touched && item.invalidPurchaseQuantity"
                        class="text-danger mt-1"
                      >
                        Item Quantity must be a positive number.
                      </div>
                    </div>

                    <!-- end of uom -->
                  </div>
                </div>
              </ng-container>

              <ng-template #noVOH>
                <div class="text-muted text-center mt-3">
                  <i class="bi bi-info-circle me-2"></i>
                  No Variable Costs Found. Click “Add fixed cost” to begin
                </div>
              </ng-template>
            </div>
          </div>
          <!-- variable overheads end -->
        </div>

        <!-- Business Challenges Tab -->

        <!-- employees TAB -->
        <div
          class="tab-pane fade pt-3"
          id="employees"
          role="tabpanel"
          aria-labelledby="employees-tab"
          [class.show]="mainActiveTab === 'employees'"
          [class.active]="mainActiveTab === 'employees'"
          [hidden]="mainActiveTab !== 'employees'"
        >
          <div class="mt-4" style="max-height: 100vh">
            <div class="border-0">
              <div class="p-4">
                <!-- Sub-tabs for Employees vs Salary Management -->
                <ul
                  class="nav nav-tabs mb-4 border-0"
                  style="margin-left: 0; padding-left: 0"
                >
                  <!-- <li class="nav-item">
                    <a
                      class="nav-link"
                      [class.active]="empSubTab === 'rolesList'"
                      (click)="setEmpSubTab('rolesList')"
                      ><i class="bi bi-person-badge me-2"></i>Roles</a
                    >
                  </li> -->
                  <li class="nav-item">
                    <a
                      class="nav-link"
                      [class.active]="empSubTab === 'employeesList'"
                      (click)="setEmpSubTab('employeesList')"
                      style="margin-left: 0"
                      ><i class="bi bi-people me-2"></i>Employees</a
                    >
                  </li>
                  <li class="nav-item">
                    <a
                      class="nav-link"
                      [class.active]="empSubTab === 'salariesList'"
                      (click)="setEmpSubTab('salariesList')"
                      ><i class="bi bi-cash-coin me-2"></i>Salary Management</a
                    >
                  </li>
                </ul>

                <!--  Roles Sub-pane Content START -->
                <!-- <div
                  *ngIf="!loading && empSubTab === 'rolesList'"
                  class="roles-subpane"
                >
                  <div
                    class="d-flex justify-content-between align-items-center mb-4"
                  >
                    <h5 class="fw-bold mb-0" style="color: #007a8f">
                      <i class="bi bi-person-badge me-2"></i>Roles List
                    </h5>
                    <div class="d-flex gap-2">
                      <button
                        class="btn btn-sm py-1 px-3"
                        style="background-color: #007a8f; color: white"
                        (click)="openSaveAllChangesModal()"
                        [disabled]="!hasPendingChanges()"
                      >
                        <i class="bi bi-cloud-arrow-up me-1"></i> Save Changes
                      </button>
                      <button
                        class="btn btn-sm py-1 px-3"
                        style="background-color: #007a8f; color: white"
                        (click)="addNewRole()"
                      >
                        <i class="bi bi-plus-lg me-1"></i> Add Role
                      </button>
                    </div>
                  </div>

                  <div
                    *ngIf="roles.length"
                    class="fixed-card table-responsive fixed-overhead-scroll"
                  >
                    <table
                      class="table table-hover align-middle mb-0 table-fixed-layout"
                    >
                      <thead class="table-light text-black">
                        <tr class="bg-primary text-black tracking-wide">
                          <th
                            style="width: 35%"
                            class="small text-black px-4 py-3 fw-semibold"
                          >
                            Role Name
                          </th>
                          <th
                            style="width: 35%"
                            class="small text-black px-4 py-3 fw-semibold"
                          >
                            Description
                          </th>
                          <th
                            style="width: 30%"
                            class="small text-black px-4 py-3 fw-semibold"
                          >
                            Actions
                          </th>
                        </tr>
                      </thead>
                      <tbody class="scrollable-container fixed-overhead-scroll">
                        <tr
                          *ngFor="let role of roles; let i = index"
                          class="border-top hover-highlight scrollable-container"
                        >
                          <td class="px-4 py-3">
                            <ng-container
                              *ngIf="
                                role.isEditing || role.isNew;
                                else nameText
                              "
                            >
                              <input
                                type="text"
                                class="form-control form-control-sm"
                                [(ngModel)]="role.roleName"
                                placeholder="Role Name"
                                name="roleName_{{ role.roleID || 'new_' + i }}"
                              />
                            </ng-container>
                            <ng-template #nameText>
                              {{ role.roleName }}
                            </ng-template>
                          </td>

                          <td class="px-4 py-3">
                            <ng-container
                              *ngIf="
                                role.isEditing || role.isNew;
                                else descText
                              "
                            >
                              <input
                                type="text"
                                class="form-control form-control-sm"
                                [(ngModel)]="role.description"
                                placeholder="Description"
                                name="roleDescription_{{
                                  role.roleID || 'new_' + i
                                }}"
                              />
                            </ng-container>
                            <ng-template #descText>
                              {{ role.description || "—" }}
                            </ng-template>
                          </td>

                          <td class="px-4 py-3">
                            <div class="d-flex gap-1">
                              <ng-container
                                *ngIf="
                                  role.isEditing || role.isNew;
                                  else viewActions
                                "
                              >
                                <button
                                  class="btn btn-sm btn-link text-success"
                                  (click)="saveRoleInline(role, i)"
                                  title="Save"
                                >
                                  <i class="bi bi-check-lg"></i>
                                </button>
                                <button
                                  class="btn btn-sm btn-link text-secondary"
                                  (click)="cancelRoleEdit(role, i)"
                                  title="Cancel"
                                >
                                  <i class="bi bi-x-lg"></i>
                                </button>
                              </ng-container>
                              <ng-template #viewActions>
                                <button
                                  class="btn btn-sm btn-outline-primary hover-scale"
                                  (click)="startEditRole(role)"
                                  title="Edit"
                                >
                                  <i class="bi bi-pencil"></i>
                                </button>
                                <button
                                  class="btn btn-sm btn-outline-danger hover-scale"
                                  (click)="markRoleForDeletion(role)"
                                  title="Delete"
                                >
                                  <i class="bi bi-trash"></i>
                                </button>
                              </ng-template>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div
                    *ngIf="!roles.length"
                    class="border rounded bg-light p-5 text-center"
                  >
                    <i
                      class="bi bi-person-badge fs-1"
                      style="color: #007a8f"
                    ></i>
                    <p class="mt-2 mb-0 fw-medium">No roles added</p>
                    <small class="text-muted"
                      >Add your first role to get started</small
                    >
                  </div>
                </div> -->
                <!-- EMPLOYEES LIST TAB -->
                <div *ngIf="loading" class="text-center py-4">
                  <div class="spinner-border text-primary" role="status">
                    <span class="visually-hidden">Loading...</span>
                  </div>
                  <p class="mt-2">Loading data...</p>
                </div>

                <div *ngIf="errorMessage" class="alert alert-danger mb-4">
                  <i class="bi bi-exclamation-triangle me-2"></i
                  >{{ errorMessage }}
                </div>

                <div
                  *ngIf="!loading && empSubTab === 'employeesList'"
                  class="employees-subpane form-section employees-section mb-4"
                >
                  <div class="section-header-overhead">
                    <div class="section-header mb-0">
                      <div class="section-icon">
                        <i class="bi bi-people"></i>
                      </div>
                      <h4 class="section-title">Employees</h4>
                    </div>
                    <div class="d-flex gap-2">
                      <!-- <button
                        class="btn btn-sm py-1 px-3"
                        style="background-color: #007a8f; color: white"
                        (click)="openSaveAllEmployeesModal()"
                        [disabled]="!hasPendingEmployeeChanges()"
                      >
                        <i class="bi bi-cloud-arrow-up me-1"></i> Save Changes
                      </button> -->
                      <button
                        type="button"
                        class="btn btn-teal-gradient text"
                        (click)="addNewEmployee()"
                      >
                        <i class="bi bi-plus-lg me-1"></i>Add Employee
                      </button>

                    </div>
                  </div>

                  <div
                    *ngIf="employees.length"
                    class="table-responsive"
                  >
                    <table
                      class="table table-hover align-middle"
                    >
                      <thead class="table-light">
                        <tr class="bg-primary text-black tracking-wide">
                          <th
                            style="width: 15%"
                            class="small text-black px-4 py-3 fw-semibold"
                          >
                            First Name
                          </th>
                          <th
                            style="width: 15%"
                            class="small text-black px-4 py-3 fw-semibold"
                          >
                            Last Name
                          </th>

                          <th
                            style="width: 15%"
                            class="small text-black px-4 py-3 fw-semibold"
                          >
                            Role
                          </th>

                          <th
                            style="width: 10%"
                            class="small text-black px-4 py-3 fw-semibold"
                          >
                            Actions
                          </th>
                        </tr>
                      </thead>
                      <tbody class="scrollable-content">
                        <tr
                          *ngFor="let emp of employees; let i = index"
                          class="border-top hover-highlight"
                        >
                          <!-- FIRST NAME -->
                          <td class="px-4 py-3">
                            <ng-container
                              *ngIf="
                                emp.isEditing || emp.isNew;
                                else firstNameText
                              "
                            >
                              <input
                                type="text"
                                class="form-control form-control-sm"
                                [(ngModel)]="emp.firstName"
                                placeholder="First Name"
                                name="firstName_{{
                                  emp.employeeID || 'new_' + i
                                }}"
                                required
                              />
                            </ng-container>
                            <ng-template #firstNameText>
                              {{ emp.firstName }}
                            </ng-template>
                          </td>
                          <!-- LAST NAME -->
                          <td class="px-4 py-3">
                            <ng-container
                              *ngIf="
                                emp.isEditing || emp.isNew;
                                else lastNameText
                              "
                            >
                              <input
                                type="text"
                                class="form-control form-control-sm"
                                [(ngModel)]="emp.lastName"
                                placeholder="Last Name"
                                name="lastName_{{
                                  emp.employeeID || 'new_' + i
                                }}"
                                required
                              />
                            </ng-container>
                            <ng-template #lastNameText>
                              {{ emp.lastName }}
                            </ng-template>
                          </td>

                          <!-- ROLE ROW -->
                          <td class="px-4 py-3">
                            <ng-container
                              *ngIf="emp.isEditing || emp.isNew; else roleText"
                            >
                              <div class="input-group">
                                <select
                                  class="form-select form-select-sm"
                                  [(ngModel)]="emp.roleID"
                                  name="roleID_{{ emp.employeeID || 'new_' + i }}"
                                  (change)="onEmployeeFieldChange(emp)"
                                >
                                  <option [ngValue]="null" disabled>
                                    Select Role
                                  </option>
                                  <ng-container *ngFor="let role of roles">
                                    <option
                                      *ngIf="!role.isAdmin"
                                      [ngValue]="role.roleID"
                                    >
                                      {{ role.roleName }}
                                    </option>
                                  </ng-container>
                                  <option class="text-primary fs-6"  [ngValue]="0">
                                    Custom Role
                                  </option>
                                </select>

                              </div>
                            </ng-container>

                            <ng-template #roleText>
                              {{ emp.roleDescription || "—" }}
                            </ng-template>
                          </td>

                          <!-- SAVE -->
                          <td class="px-4 py-3">
                            <div class="d-flex gap-1">
                              <ng-container
                                *ngIf="
                                  emp.isEditing || emp.isNew;
                                  else viewActions
                                "
                              >
                                <button
                                  type="button"
                                  class="btn btn-sm btn-link text-success"
                                  (click)="saveEmployeeInline(emp, i)"
                                  title="Save"
                                  [disabled]="
                                    !emp.firstName ||
                                    !emp.lastName ||
                                    !emp.hireDate ||
                                    emp.roleID === null
                                  "
                                >
                                  <i class="bi bi-floppy fs-5 text-primary"></i>
                                </button>
                                <button
                                  type="button"
                                  class="btn btn-sm btn-link text-secondary"
                                  (click)="cancelEmployeeEdit(emp, i)"
                                  title="Cancel"
                                >
                                  <i class="bi bi-x-lg fs-5"></i>
                                </button>
                              </ng-container>
                              <ng-template #viewActions>
                                <button
                                  type="button"
                                  class="btn btn-sm btn-outline-primary hover-scale"
                                  (click)="startEditEmployee(emp)"
                                  title="Edit"
                                >
                                  <i class="bi bi-pencil fs-5"></i>
                                </button>
                                <button
                                  type="button"
                                  class="btn btn-sm btn-outline-danger hover-scale"
                                  (click)="markEmployeeForDeletion(emp)"
                                  title="Delete"
                                >
                                  <i class="bi bi-trash fs-5"></i>
                                </button>
                              </ng-template>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div
                    *ngIf="!employees.length && !loading"
                    class="border rounded bg-light p-5 text-center"
                  >
                    <i class="bi bi-people fs-1" style="color: #007a8f"></i>
                    <p class="mt-2 mb-0 fw-medium">No employees added</p>
                    <small class="text-muted"
                      >Add your first employee to get started</small
                    >
                  </div>
                </div>
                <!-- End Employees List Sub-pane -->

                <!-- Salary Management Sub-pane START -->
                <div
                  *ngIf="!loading && empSubTab === 'salariesList'"
                  class="salaries-subpane form-section salary-section mb-4"
                >
                  <div class="section-header-overhead">
                    <div class="section-header mb-0">
                      <div class="section-icon">
                        <i class="bi bi-cash-coin"></i>
                      </div>
                      <h4 class="section-title">Salary Management</h4>
                    </div>
                    <div class="d-flex gap-2">
                      <!-- <button
                        class="btn btn-sm py-1 px-3"
                        style="background-color: #007a8f; color: white"
                        (click)="openSaveAllSalariesModal()"
                        [disabled]="!hasPendingSalaryChanges()"
                      >
                        <i class="bi bi-cloud-arrow-up me-1"></i> Save Changes
                      </button> -->
                      <button
                        type="button"
                        class="btn btn-sm py-1 px-3"
                        style="background-color: #007a8f; color: white"
                        (click)="addNewSalary()"
                      >
                        <i class="bi bi-plus-lg me-1"></i> Add Salary Record
                      </button>
                    </div>
                  </div>

                  <div
                    *ngIf="employeeSalaries.length"
                    class="fixed-card table-responsive fixed-overhead-scroll"
                  >
                    <!-- TABLE HEADER EMPLOYEE SALARIES -->
                    <table
                      class="table table-hover align-middle mb-0 table-fixed-layout sleek-salary-table"
                    >
                      <thead class="table-light text-black">
                        <tr class="bg-primary text-black tracking-wide">
                          <th
                            style="width: 18%"
                            class="small text-black px-4 py-3 fw-semibold"
                          >
                            Employee
                          </th>
                          <th
                            style="width: 18%"
                            class="small text-black px-4 py-3 fw-semibold"
                          >
                            Payment Rate Type
                          </th>

                          <th
                            style="width: 12%"
                            class="small text-black px-4 py-3 fw-semibold"
                          >
                            Amount Paid
                          </th>
                          <th
                            style="width: 12%"
                            class="small text-black px-4 py-3 fw-semibold"
                          >
                            Hours Worked
                          </th>
                          <th
                            style="width: 10%"
                            class="small text-black px-4 py-3 fw-semibold"
                          >
                            Actions
                          </th>
                        </tr>
                      </thead>
                      <!-- TABLE EMPLOYEE SALARIES -->
                      <!-- employee select -->
                      <tbody class="scrollable-content">
                        <tr
                          *ngFor="let salary of employeeSalaries; let i = index"
                          class="border-top"
                        >
                          <td class="px-4 py-3">
                            <ng-container
                              *ngIf="
                                salary.isEditing || salary.isNew;
                                else employeeNameText
                              "
                            >
                              <select
                                class="form-select form-select-sm sleek-input"
                                [(ngModel)]="salary.employeeID"
                                name="employeeSelect{{ salary.salaryID }}"
                                (change)="
                                  onSalaryFieldChange(salary, 'employeeID')
                                "
                              >
                                <option [ngValue]="null" disabled selected>
                                  Select Employee
                                </option>
                                <option
                                  *ngFor="let emp of employees"
                                  [value]="emp.employeeID"
                                >
                                  {{ emp.firstName }} {{ emp.lastName }}
                                </option>
                              </select>
                            </ng-container>

                            <ng-template #employeeNameText>
                              {{ getEmployeeName(salary.employeeID) }}
                            </ng-template>
                          </td>
                          <!-- period type -->
                          <td class="px-4 py-3">
                            <ng-container
                              *ngIf="
                                salary.isEditing || salary.isNew;
                                else periodTypeText
                              "
                            >
                              <select
                                class="form-select form-select-sm"
                                [(ngModel)]="salary.periodTypeID"
                                name="periodTypeID_{{
                                  salary.salaryID || 'new_' + i
                                }}"
                                required
                                (change)="
                                  onSalaryFieldChange(salary, 'periodTypeID')
                                "
                              >
                                <option [ngValue]="null" disabled>
                                  Select Period Type
                                </option>
                                <option
                                  *ngFor="let pt of periodTypes"
                                  [ngValue]="pt.periodTypeID"
                                >
                                  {{ pt.description }}
                                </option>
                              </select>
                            </ng-container>
                            <ng-template #periodTypeText>
                              {{
                                getPeriodTypeDescription(salary.periodTypeID)
                              }}
                            </ng-template>
                          </td>

                          <!-- amount salary -->
                          <td class="px-3 py-2">
                            <ng-container
                              *ngIf="
                                salary.isEditing || salary.isNew;
                                else amountText
                              "
                            >
                              <div class="currency-input-group">
                                <input
                                  type="text"
                                  class="currency-select"
                                  [value]="salary.currency"
                                  readonly
                                />
                                <input
                                  type="number"
                                  class="amount-input"
                                  [(ngModel)]="salary.amount"
                                  name="amount_{{
                                    salary.salaryID || 'new_' + i
                                  }}"
                                  step="0.01"
                                  placeholder="0.00"
                                  (change)="
                                    onSalaryFieldChange(salary, 'amount')
                                  "
                                />
                              </div>
                            </ng-container>
                            <ng-template #amountText>
                              <div class="currency-display">
                                <span class="currency-badge">{{
                                  salary.currency
                                }}</span>
                                {{ salary.amount | number : "1.2-2" }}
                              </div>
                            </ng-template>
                          </td>
                          <!-- hours -->
                          <td class="px-4 py-3">
                            <ng-container
                              *ngIf="
                                salary.isEditing || salary.isNew;
                                else hoursWorkedText
                              "
                            >
                              <input
                                type="number"
                                class="form-control form-control-sm"
                                [(ngModel)]="salary.hoursWorked"
                                name="hoursWorked_{{
                                  salary.salaryID || 'new_' + i
                                }}"
                                step="0.01"
                                placeholder="0.00"
                                required
                                [readonly]="isHourlyPaymentType(salary)"
                                [class.readonly-field]="isHourlyPaymentType(salary)"
                                (change)="
                                  onSalaryFieldChange(salary, 'hoursWorked')
                                "
                              />
                            </ng-container>
                            <ng-template #hoursWorkedText>
                              {{ salary.hoursWorked | number : "1.2-2" }}
                            </ng-template>
                          </td>
                          <!-- actions -->
                          <td class="px-4 py-3">
                            <div class="d-flex gap-1">
                              <ng-container
                                *ngIf="
                                  salary.isEditing || salary.isNew;
                                  else viewActionsSalary
                                "
                              >
                                <button
                                  type="button"
                                  class="btn btn-sm btn-link text-success"
                                  (click)="saveSalaryInline(salary, i)"
                                  [disabled]="!canSave(salary)"
                                  title="Save"
                                >
                                  <i class="bi bi-floppy fs-5 text-primary"></i>
                                </button>
                                <button
                                  type="button"
                                  class="btn btn-sm btn-link text-secondary"
                                  (click)="cancelSalaryEdit(salary, i)"
                                  title="Cancel"
                                >
                                  <i class="bi bi-x-lg fs-5"></i>
                                </button>
                              </ng-container>
                              <ng-template #viewActionsSalary>
                                <button
                                  type="button"
                                  class="btn btn-sm btn-outline-primary hover-scale"
                                  (click)="startEditSalary(salary)"
                                  title="Edit"
                                >
                                  <i class="bi bi-pencil fs-5"></i>
                                </button>
                                <button
                                  type="button"
                                  class="btn btn-sm btn-outline-danger hover-scale"
                                  (click)="markSalaryForDeletion(salary)"
                                  title="Delete"
                                >
                                  <i class="bi bi-trash fs-5"></i>
                                </button>
                              </ng-template>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div
                    *ngIf="!employeeSalaries.length && !loading"
                    class="border rounded bg-light p-5 text-center"
                  >
                    <i class="bi bi-cash-coin fs-1" style="color: #007a8f"></i>
                    <p class="mt-2 mb-0 fw-medium">No salary records</p>
                    <small class="text-muted"
                      >Add your first salary record to get started</small
                    >
                  </div>
                </div>
                <!-- End Salary Management Sub-pane -->
              </div>
            </div>
          </div>
        </div>

        <!-- end of employee tab -->
        <div class="d-flex justify-content-end mt-4">
          <button
            type="button"
            class="btn btn-teal-gradient px-4 py-3 rounded-1"
            (click)="saveAndContinue()"
          >
            <i class="bi bi-cloud-arrow-up me-2"></i>
            <span class="fw-medium">{{ saveButtonLabel }}</span>
          </button>
        </div>
        <!-- MODAL BEGIN -->

        <!-- END OF MODAL -->
      </div>
    </form>
  </div>

  <!-- Welcome onboarding modal — shown on first login until dismissed -->
  <div class="modal-overlay" *ngIf="isFirstLogin && !welcomeDismissed" (click)="$event.stopPropagation()">
    <div class="modal-content" (click)="$event.stopPropagation()">
      <div class="modal-header">
        <h5 class="modal-title">Welcome to Aivor!</h5>
      </div>
      <div class="modal-body">
        <p class="confirmation-text">Let's set up your business. Click <strong>Save &amp; Continue</strong> on each tab to progress through <strong>Details</strong>, <strong>Schedule</strong>, <strong>Expenses</strong>, <strong>Employees</strong>, and <strong>Salaries</strong>. You'll get access to the rest of the app once setup is complete.</p>
      </div>
      <div class="modal-footer">
        <button class="btn btn-save" (click)="welcomeDismissed = true">Got it</button>
      </div>
    </div>
  </div>
  <div
    class="modal-overlay"
    [class.active]="showSaveModal"
    (click)="closeSaveModal()"
  >
    <div class="modal-content" (click)="$event.stopPropagation()">
      <div class="modal-header">
        <h5 class="modal-title">Confirm Changes</h5>
        <button class="close-btn" (click)="closeSaveModal()">
          <svg width="16" height="16" viewBox="0 0 16 16">
            <path
              fill="currentColor"
              d="M14.7 1.3c-.4-.4-1-.4-1.4 0L8 6.6 2.7 1.3C2.3.9 1.7.9 1.3 1.3s-.4 1 0 1.4L6.6 8l-5.3 5.3c-.4.4-.4 1 0 1.4.2.2.5.3.7.3s.5-.1.7-.3L8 9.4l5.3 5.3c.2.2.5.3.7.3s.5-.1.7-.3c.4-.4.4-1 0-1.4L9.4 8l5.3-5.3c.4-.4.4-1 0-1.4z"
            />
          </svg>
        </button>
      </div>

      <div class="modal-body">
        <p class="confirmation-text">
          Are you sure you want to save these changes? This will
          <strong>update records</strong> in the database.
        </p>

        <div
          *ngIf="
            pendingChanges.added.length > 0 ||
            pendingChanges.updated.length > 0 ||
            pendingChanges.deleted.length > 0
          "
          class="changes-summary mt-3"
        >
          <h6>Summary of Changes:</h6>
          <ul class="list-unstyled">
            <li *ngIf="pendingChanges.added.length > 0">
              <strong class="text-success"
                >{{ pendingChanges.added.length }} New Role(s):</strong
              >
              <ul>
                <li *ngFor="let role of pendingChanges.added">
                  {{ role.roleName }}
                </li>
              </ul>
            </li>
            <li *ngIf="pendingChanges.updated.length > 0">
              <strong class="text-warning"
                >{{ pendingChanges.updated.length }} Updated Role(s):</strong
              >
              <ul>
                <li *ngFor="let role of pendingChanges.updated">
                  {{ role.roleName }}
                </li>
              </ul>
            </li>
            <li *ngIf="pendingChanges.deleted.length > 0">
              <strong class="text-danger"
                >{{ pendingChanges.deleted.length }} Deleted Role(s):</strong
              >
              <ul>
                <li *ngFor="let role of pendingChanges.deleted">
                  {{ role.roleName }}
                </li>
              </ul>
            </li>
          </ul>
        </div>
        <div *ngIf="modalMessage" class="status-message mt-3">
          <div
            [ngClass]="{
              success: isSuccess,
              error: isSuccess === false
            }"
          >
            <div [innerHTML]="modalMessage"></div>
          </div>
        </div>
      </div>

      <div class="modal-footer">
        <button
          class="btn btn-cancel"
          [disabled]="isSaving"
          (click)="closeSaveModal()"
        >
          Cancel
        </button>

        <button
          class="btn btn-save"
          (click)="confirmSaveAllChanges()"
          [disabled]="isSaving"
        >
          <span
            *ngIf="isSaving"
            class="spinner-border spinner-border-sm"
            role="status"
            aria-hidden="true"
          ></span>
          {{ isSaving ? "Saving..." : "Confirm Changes" }}
        </button>
      </div>
    </div>
  </div>
  <!-- ROLE MODAL END -->
  <!-- EMPLOYEE SAVE MODAL BEGIN -->
  <div
    class="modal-overlay"
    [class.active]="showSaveEmployeeModal"
    (click)="closeSaveEmployeeModal()"
  >
    <div class="modal-content" (click)="$event.stopPropagation()">
      <div class="modal-header">
        <h5 class="modal-title">Confirm Employee Changes</h5>
        <button class="close-btn" (click)="closeSaveEmployeeModal()">
          <svg width="16" height="16" viewBox="0 0 16 16">
            <path
              fill="currentColor"
              d="M14.7 1.3c-.4-.4-1-.4-1.4 0L8 6.6 2.7 1.3C2.3.9 1.7.9 1.3 1.3s-.4 1 0 1.4L6.6 8l-5.3 5.3c-.4.4-.4 1 0 1.4.2.2.5.3.7.3s.5-.1.7-.3L8 9.4l5.3 5.3c.2.2.5.3.7.3s.5-.1.7-.3c.4-.4.4-1 0-1.4L9.4 8l5.3-5.3c.4-.4.4-1 0-1.4z"
            />
          </svg>
        </button>
      </div>

      <div class="modal-body">
        <p class="confirmation-text">
          Are you sure you want to save these employee changes? This will
          <strong>update records</strong> in the database.
        </p>

        <div
          *ngIf="
            pendingEmployeeChanges.added.length > 0 ||
            pendingEmployeeChanges.updated.length > 0 ||
            pendingEmployeeChanges.deleted.length > 0
          "
          class="changes-summary mt-3"
        >
          <h6>Summary of Employee Changes:</h6>
          <ul class="list-unstyled">
            <li *ngIf="pendingEmployeeChanges.added.length > 0">
              <strong class="text-success"
                >{{ pendingEmployeeChanges.added.length }} New
                Employee(s):</strong
              >
              <ul>
                <li *ngFor="let emp of pendingEmployeeChanges.added">
                  {{ emp.firstName }} {{ emp.lastName }}
                </li>
              </ul>
            </li>
            <li *ngIf="pendingEmployeeChanges.updated.length > 0">
              <strong class="text-warning"
                >{{ pendingEmployeeChanges.updated.length }} Updated
                Employee(s):</strong
              >
              <ul>
                <li *ngFor="let emp of pendingEmployeeChanges.updated">
                  {{ emp.firstName }} {{ emp.lastName }}
                </li>
              </ul>
            </li>
            <li *ngIf="pendingEmployeeChanges.deleted.length > 0">
              <strong class="text-danger"
                >{{ pendingEmployeeChanges.deleted.length }} Deleted
                Employee(s):</strong
              >
              <ul>
                <li *ngFor="let emp of pendingEmployeeChanges.deleted">
                  {{ emp.firstName }} {{ emp.lastName }}
                </li>
              </ul>
            </li>
          </ul>
        </div>
        <div *ngIf="employeeModalMessage" class="status-message mt-3">
          <div
            [ngClass]="{
              success: isEmployeeSaveSuccess,
              error: isEmployeeSaveSuccess === false
            }"
          >
            <div class="mx-auto" [innerHTML]="employeeModalMessage"></div>
          </div>
        </div>
      </div>

      <div class="modal-footer">
        <button
          class="btn btn-cancel"
          [disabled]="isSavingEmployees"
          (click)="closeSaveEmployeeModal()"
        >
          Cancel
        </button>

        <button
          class="btn btn-save"
          (click)="confirmSaveAllEmployeesChanges()"
          [disabled]="isSavingEmployees"
        >
          <span
            *ngIf="isSavingEmployees"
            class="spinner-border spinner-border-sm"
            role="status"
            aria-hidden="true"
          ></span>
          {{ isSavingEmployees ? "Saving..." : "Confirm Changes" }}
        </button>
      </div>
    </div>
  </div>
  <!-- END EMPLOYEE MODAL -->
  <!-- BEGIN SALARIES MODAL -->
  <div
    class="modal-overlay"
    [class.active]="showSaveSalaryModal"
    (click)="closeSaveSalaryModal()"
  >
    <div class="modal-content" (click)="$event.stopPropagation()">
      <div class="modal-header">
        <h5 class="modal-title">Confirm Salary Changes</h5>
        <button class="close-btn" (click)="closeSaveSalaryModal()">
          <svg width="16" height="16" viewBox="0 0 16 16">
            <path
              fill="currentColor"
              d="M14.7 1.3c-.4-.4-1-.4-1.4 0L8 6.6 2.7 1.3C2.3.9 1.7.9 1.3 1.3s-.4 1 0 1.4L6.6 8l-5.3 5.3c-.4.4-.4 1 0 1.4.2.2.5.3.7.3s.5-.1.7-.3L8 9.4l5.3 5.3c.2.2.5.3.7.3s.5-.1.7-.3c.4-.4.4-1 0-1.4L9.4 8l5.3-5.3c.4-.4.4-1 0-1.4z"
            />
          </svg>
        </button>
      </div>

      <div class="modal-body">
        <p class="confirmation-text">
          Are you sure you want to save these salary changes? This will
          <strong>update records</strong> in the database.
        </p>

        <div
          *ngIf="
            pendingSalaryChanges.added.length > 0 ||
            pendingSalaryChanges.updated.length > 0 ||
            pendingSalaryChanges.deleted.length > 0
          "
          class="changes-summary mt-3"
        >
          <h6>Summary of Salary Changes:</h6>
          <ul class="list-unstyled">
            <li *ngIf="pendingSalaryChanges.added.length > 0">
              <strong class="text-success"
                >{{ pendingSalaryChanges.added.length }} New Record(s):</strong
              >
              <ul>
                <li *ngFor="let sal of pendingSalaryChanges.added">
                  Salary for {{ getEmployeeName(sal.employeeID) }}
                </li>
              </ul>
            </li>
            <li *ngIf="pendingSalaryChanges.updated.length > 0">
              <strong class="text-warning"
                >{{ pendingSalaryChanges.updated.length }} Updated
                Record(s):</strong
              >
              <ul>
                <li *ngFor="let sal of pendingSalaryChanges.updated">
                  Salary for {{ getEmployeeName(sal.employeeID) }}
                </li>
              </ul>
            </li>
            <li *ngIf="pendingSalaryChanges.deleted.length > 0">
              <strong class="text-danger">
                {{ pendingSalaryChanges.deleted.length }} Deleted Record(s):
              </strong>
              <ul>
                <li *ngFor="let salaryId of pendingSalaryChanges.deleted">
                  Salary ID: {{ salaryId }} (Marked for deletion)
                </li>
              </ul>
            </li>
          </ul>
        </div>
        <div *ngIf="salaryModalMessage" class="status-message mt-3">
          <div
            [ngClass]="{
              success: isSalarySaveSuccess,
              error: isSalarySaveSuccess === false
            }"
          >
            {{ salaryModalMessage }}
          </div>
        </div>
      </div>

      <div class="modal-footer">
        <button
          class="btn btn-cancel"
          [disabled]="isSavingSalaries"
          (click)="closeSaveSalaryModal()"
        >
          Cancel
        </button>

        <button
          class="btn btn-save"
          (click)="confirmSaveAllSalariesChanges()"
          [disabled]="isSavingSalaries"
        >
          <span
            *ngIf="isSavingSalaries"
            class="spinner-border spinner-border-sm"
            role="status"
            aria-hidden="true"
          ></span>
          {{ isSavingSalaries ? "Saving..." : "Confirm Changes" }}
        </button>
      </div>
    </div>
  </div>
  <!-- END SALARIES MODAL -->
  <!-- BEGIN ALERT MODAL -->
  <div
    class="modal-overlay"
    [class.active]="showMessageModal"
    (click)="closeShowMessageModal()"
  >
    <div class="modal-content" (click)="$event.stopPropagation()">
      <div class="modal-header">
        <h5 class="modal-title mx-auto">System Message</h5>
        <button class="close-btn" (click)="closeShowMessageModal()">
          <svg width="16" height="16" viewBox="0 0 16 16">
            <path
              fill="currentColor"
              d="M14.7 1.3c-.4-.4-1-.4-1.4 0L8 6.6 2.7 1.3C2.3.9 1.7.9 1.3 1.3s-.4 1 0 1.4L6.6 8l-5.3 5.3c-.4.4-.4 1 0 1.4.2.2.5.3.7.3s.5-.1.7-.3L8 9.4l5.3 5.3c.2.2.5.3.7.3s.5-.1.7-.3c.4-.4.4-1 0-1.4L9.4 8l5.3-5.3c.4-.4.4-1 0-1.4z"
            />
          </svg>
        </button>
      </div>

      <div class="modal-body mx-auto">
        <strong class="confirmation-text mx-auto">
          <div class="mx-auto" [innerHTML]="alertInfo"></div>
        </strong>
      </div>
      <div class="modal-footer">
        <button
          class="btn btn-save mx-auto"
          [disabled]="isSavingSalaries"
          (click)="closeShowMessageModal()"
        >
          Close
        </button>
      </div>
    </div>
  </div>
  <!-- delettion modal -->
  <div
    class="modal-overlay"
    [class.active]="showDeleteConfirm"
    (click)="closeDeleteConfirm()"
  >
    <div class="modal-content" (click)="$event.stopPropagation()">
      <div class="modal-header">
        <h5 class="modal-title">Confirm Deletion Changes</h5>
        <button class="close-btn" (click)="closeDeleteConfirm()">
          <svg width="16" height="16" viewBox="0 0 16 16">
            <path
              fill="currentColor"
              d="M14.7 1.3c-.4-.4-1-.4-1.4 0L8 6.6 2.7 1.3C2.3.9 1.7.9 1.3 1.3s-.4 1 0 1.4L6.6 8l-5.3 5.3c-.4.4-.4 1 0 1.4.2.2.5.3.7.3s.5-.1.7-.3L8 9.4l5.3 5.3c.2.2.5.3.7.3s.5-.1.7-.3c.4-.4.4-1 0-1.4L9.4 8l5.3-5.3c.4-.4.4-1 0-1.4z"
            />
          </svg>
        </button>
      </div>
      <div class="modal-body">
        <p class="confirmation-text">
          Are you sure you remove this entry? This will
          <strong class="text-danger">delete records</strong> in the database.
        </p>
        <div *ngIf="employeeModalMessage" class="status-message mt-3">
          <div
            [ngClass]="{
              success: isEmployeeSaveSuccess,
              error: isEmployeeSaveSuccess === false
            }"
          >
            <div class="mx-auto" [innerHTML]="employeeModalMessage"></div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button class="btn btn-cancel" (click)="closeDeleteConfirm()">
          Cancel
        </button>

        <button
          class="btn btn-save"
          (click)="confirmDelete()"
          [disabled]="isSavingSalaries"
        >
          <span
            *ngIf="isSavingSalaries"
            class="spinner-border spinner-border-sm"
            role="status"
            aria-hidden="true"
          ></span>
          Confirm
        </button>
      </div>
    </div>
  </div>
</div>
</div><!-- end desktop wrapper -->
<div *ngIf="isProcessing" class="app-spinner-overlay">
  <div class="app-loading-spinner"></div>
</div>
